import React from "react";
import stand1 from "../../Images/stand1.png";
import stand2 from "../../Images/stand2.png";
import stand3 from "../../Images/stand3.png";
import stand4 from "../../Images/stand4.png";
import core1 from "../../Images/core1.png";
import core2 from "../../Images/core2.png";
import core3 from "../../Images/core3.png";
import core4 from "../../Images/core4.png";
import core5 from "../../Images/core5.png";

const WhyStandOutSection = () => {
  return (
    <div className="relative w-full text-white">
      {/* Why do we Stand Out Section - with gradient background */}
      <div className="relative w-full py-20 bg-[#1F1F1FD9]">
        {/* Subtle overlay for depth */}
        <div className="absolute inset-0 bg-black/10"></div>

        <div className="container mx-auto px-6 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-8">
              Why do we Stand Out?
            </h2>
            <p className="text-gray-200 text-lg leading-relaxed max-w-4xl mx-auto">
              We’re not just advisors—we’re bridge-builders. Our founder’s unique blend of diplomatic 
              stature, defense industry ties, and investment acumen ensures that Semars Holding delivers 
              results where others only plan. Our influence, speed, and trustworthiness define our 
              competitive edge in Saudi Arabia’s high-stakes landscape.
            </p>
          </div>

          {/* Features Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-6 max-w-6xl mx-auto">
            {/* Feature 1 */}
            <div
              className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center hover:bg-white/20 hover:shadow-2xl hover:scale-105 transition-all duration-300 border border-white/10"
              data-aos="fade-up"
              data-aos-duration="300"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-yellow-500/30 to-yellow-600/30 rounded-xl flex items-center justify-center mx-auto mb-4 shadow-lg">
                <img
                  src={stand1}
                  alt="Complete Packages Icon"
                  className="w-8 h-8"
                />
              </div>
              <h4 className="text-white font-semibold text-sm">
                Complete Packages For All Your Wishes
              </h4>
            </div>

            {/* Feature 2 */}
            <div
              className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center hover:bg-white/20 hover:shadow-2xl hover:scale-105 transition-all duration-300 border border-white/10"
              data-aos="fade-up"
              data-aos-duration="400"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-yellow-500/30 to-yellow-600/30 rounded-xl flex items-center justify-center mx-auto mb-4 shadow-lg">
                <img src={stand2} alt="Experience Icon" className="w-8 h-8" />
              </div>
              <h4 className="text-white font-semibold text-sm">
                Over 25 Years Of Experience
              </h4>
            </div>

            {/* Feature 3 */}
            <div
              className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center hover:bg-white/20 hover:shadow-2xl hover:scale-105 transition-all duration-300 border border-white/10"
              data-aos="fade-up"
              data-aos-duration="500"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-yellow-500/30 to-yellow-600/30 rounded-xl flex items-center justify-center mx-auto mb-4 shadow-lg">
                <img
                  src={stand3}
                  alt="Expert Guides Icon"
                  className="w-8 h-8"
                />
              </div>
              <h4 className="text-white font-semibold text-sm">
                Expert Guides For You
              </h4>
            </div>

            {/* Feature 4 */}
            <div
              className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center hover:bg-white/20 hover:shadow-2xl hover:scale-105 transition-all duration-300 border border-white/10"
              data-aos="fade-up"
              data-aos-duration="600"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-yellow-500/30 to-yellow-600/30 rounded-xl flex items-center justify-center mx-auto mb-4 shadow-lg">
                <img
                  src={stand4}
                  alt="Guaranteed Fun Icon"
                  className="w-8 h-8"
                />
              </div>
              <h4 className="text-white font-semibold text-sm">
                Guaranteed fun at the best price!
              </h4>
            </div>
          </div>
        </div>
      </div>

      {/* Our Core Values Section - with matching gradient background */}
      <div className="relative w-full py-20">
        {/* Subtle overlay for variation */}
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/10 to-black/20"></div>

        {/* Subtle texture overlay */}
        <div
          className="absolute inset-0 opacity-5"
          style={{
            backgroundImage: `radial-gradient(circle at 1px 1px, rgba(255,255,255,0.3) 1px, transparent 0)`,
            backgroundSize: "20px 20px",
          }}
        ></div>

        <div className="container mx-auto px-6 lg:px-8 relative z-10">
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-16 drop-shadow-lg">
              Our Core Values
            </h2>
          </div>

          {/* Core Values Grid */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 lg:gap-12 max-w-6xl mx-auto">
            {/* Integrity */}
            <div
              className="text-center group"
              data-aos="fade-up"
              data-aos-duration="300"
            >
              <div className="w-20 h-20  flex items-center justify-center mx-auto mb-4 hover:from-yellow-500/50 hover:to-amber-600/50 transition-all duration-300 group-hover:scale-110 ">
                <img
                  src={core1}
                  alt="Integrity Icon"
                  className="w-[82px] h-[75px]"
                />
              </div>
              <h4 className="text-white font-semibold text-lg group-hover:text-yellow-300 transition-colors duration-300">
                Integrity
              </h4>
            </div>

            {/* Innovation */}
            <div
              className="text-center group"
              data-aos="fade-up"
              data-aos-duration="400"
            >
              <div className="w-20 h-20  flex items-center justify-center mx-auto mb-4 hover:from-yellow-500/50 hover:to-amber-600/50 transition-all duration-300 group-hover:scale-110 ">
                <img
                  src={core2}
                  alt="Innovation Icon"
                  className="w-[82px] h-[75px]"
                />
              </div>
              <h4 className="text-white font-semibold text-lg group-hover:text-yellow-300 transition-colors duration-300">
                Innovation
              </h4>
            </div>

            {/* Commitment */}
            <div
              className="text-center group"
              data-aos="fade-up"
              data-aos-duration="500"
            >
              <div className="w-20 h-20  flex items-center justify-center mx-auto mb-4 hover:from-yellow-500/50 hover:to-amber-600/50 transition-all duration-300 group-hover:scale-110 ">
                <img
                  src={core3}
                  alt="Commitment Icon"
                  className="w-[82px] h-[75px]"
                />
              </div>
              <h4 className="text-white font-semibold text-lg group-hover:text-yellow-300 transition-colors duration-300">
                Confidentiality
              </h4>
            </div>

            {/* Excellence */}
            <div
              className="text-center group"
              data-aos="fade-up"
              data-aos-duration="600"
            >
              <div className="w-20 h-20  flex items-center justify-center mx-auto mb-4 hover:from-yellow-500/50 hover:to-amber-600/50 transition-all duration-300 group-hover:scale-110 ">
                <img
                  src={core4}
                  alt="Excellence Icon"
                  className="w-[82px] h-[75px]"
                />
              </div>
              <h4 className="text-white font-semibold text-lg group-hover:text-yellow-300 transition-colors duration-300">
                Loyalty
              </h4>
            </div>

            {/* Expertise */}
            <div
              className="text-center group"
              data-aos="fade-up"
              data-aos-duration="700"
            >
              <div className="w-20 h-20  flex items-center justify-center mx-auto mb-4 hover:from-yellow-500/50 hover:to-amber-600/50 transition-all duration-300 group-hover:scale-110 ">
                <img
                  src={core5}
                  alt="Expertise Icon"
                  className="w-[82px] h-[75px]"
                />
              </div>
              <h4 className="text-white font-semibold text-lg group-hover:text-yellow-300 transition-colors duration-300">
                Cultural Alignment
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyStandOutSection;
